import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { CreateCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/customers-service-lib/src/wrapper/inputs/customers/create-customer.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomerCreateFormStep1Controller } from '@app/feature/customer/customer-create/customer-create-form-step-1/customer-create-form-step-1.controller';
import { CustomerCreateFormStep2Controller } from '@app/feature/customer/customer-create/customer-create-form-step-2/customer-create-form-step-2.controller';
import { useCreateCustomerContext } from '@app/feature/customer/customer.context';

interface CustomerCreateFormControllerProps {
  onError: SubmitErrorHandler<CreateCustomerModel>;
  onSubmit: SubmitHandlerWithDirtyFields<CreateCustomerModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const CustomerCreateFormController = ({
  onError,
  onSubmit,
  onCancel,
  state,
}: CustomerCreateFormControllerProps): React.JSX.Element => {
  const { t } = useTranslation();
  const data = useCreateCustomerContext();

  return (
    <MultiStepFormProvider<CreateCustomerModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          title: t('$.customer-create.step-1.title'),
          iconName: 'dataflow-04',
          fields: [
            'name',
            'holder.companyName',
            'holder.siret',
            'holder.vatNumber',
            'holder.address.address',
            'holder.address.city',
            'holder.address.zipCode',
            'holder.address.countryCode',
            'holder.firstName',
            'holder.lastName',
            'holder.email',
            'defaultUser.defaultRoleName',
            'defaultUser.firstName',
            'defaultUser.lastName',
            'defaultUser.emailAddress',
            'defaultNetworkName',
          ],
          component: <CustomerCreateFormStep1Controller />,
        },
        {
          title: t('$.customer-create.step-2.title'),
          iconName: 'marker-pin-04',
          fields: [
            'subscriptionId',
            'commissionPercentage',
            'billingDetails.firstName',
            'billingDetails.lastName',
            'billingDetails.address.address',
            'billingDetails.address.city',
            'billingDetails.address.zipCode',
            'billingDetails.address.countryCode',
            'isExemptFromBilling',
            'billingDetails.bic',
            'billingDetails.iban',
            'billingDetails.mandate.dateOfSignature',
            'billingDetails.mandate.documentNumber',
          ],
          component: <CustomerCreateFormStep2Controller />,
        },
      ]}
    />
  );
};
